<script lang="ts">
	import { t } from 'svelte-i18n';
	import { afterUpdate } from 'svelte';
	import PageHead from '@app/components/PageHead.svelte';
	import SwipeableArticles from '@app/components/blog/SwipeableArticles.svelte';
	import HeroBlog from '@app/components/cms/blog/HeroBlog.svelte';
	import AvatarContent from '@app/components/blog/AvatarContent.svelte';
	import ArticleContent from '@app/components/blog/ArticleContent.svelte';
	export let data;

	$: ({ article, endArticleBloc, similarArticles } = data);
	let articleContent;
	let currentYPosition: number;
	let percentageOfReading: number;

	afterUpdate(() => {
		let time = Math.ceil(articleContent.innerText.match(/\w+/g).length / 200);
		percentageOfReading = (100 * currentYPosition) / articleContent.offsetHeight;
	});
</script>

<svelte:window bind:scrollY={currentYPosition} />

{#if article && article.content}
	<PageHead
		title={article.content.metaTitle}
		desc={article.content.metaDescription}
		shareImage={article.content.imageHeader.filename}
	/>
	{#if percentageOfReading > 0}
		<div class="fixed top-0 bg-dashboardBg w-full z-[1995]">
			<div
				class="bg-primary h-2"
				style="width: {percentageOfReading > 100 ? 100 : percentageOfReading}%; "
			/>
		</div>
	{/if}
	<HeroBlog
		title
		image={article.content.imageHeader}
		{article}
		classNames=" border-b-4 border-primary max-h-[380px] md:max-h-[650px]"
	/>
	<article class="post relative" bind:this={articleContent}>
		<div class="lg:container">
			<h1 class=" md:text-6xl text-center md:text-left text-4xl mt-6 ml-0">
				{article.content.title}
			</h1>
			<div class=" postContainer md:grid mt-5">
				<AvatarContent {article} />
				<ArticleContent {article} />
			</div>
		</div>
	</article>
	<SwipeableArticles
		articles={similarArticles?.slice(0, 3)}
		title={$t('blog.similarArticles')}
		classNames={'postContainer container lg:grid  my-7 '}
		numberGrid={3}
	/>
	{#if endArticleBloc.length}
		{#each endArticleBloc as comp}
			<svelte:component this={comp.svelteComp} blok={comp.CMSComp} />
		{/each}
	{/if}
{/if}

<style lang="postcss">
	.postContainer {
		grid-template-columns: 25% 75%;
	}
	.post :global(.narrow-inner-container) {
		padding: 0;
	}
</style>
